;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/admin/:tool*?\",\"regex\":\"^/admin(?:/(.*))?$\",\"paramNames\":[\"tool\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/privacy-policy\"},{\"path\":\"/terms-of-service\"},{\"path\":\"/sentry-example-page\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.7";globalThis["_sentryRewritesTunnelPath"] = "/sentry-tunnel";import * as Sentry from '@sentry/nextjs';

import {
  getSentryDsn,
  getSentryEnvironment,
  getSentryRelease,
  getTracesSampleRate,
  isSentryEnabled,
} from '@/lib/sentry/options';

if (isSentryEnabled('client')) {
  Sentry.init({
    dsn: getSentryDsn('client'),
    environment: getSentryEnvironment(),
    release: getSentryRelease(),
    tracesSampleRate: getTracesSampleRate(),
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
